const { feWp } = window;
const { addAction } = feWp.hooks;

// Function to stop autoplay on the slider object
const stopAutoPlay = ( sliderObj ) => {
  sliderObj.autoplay.stop();
};

// Function to set animation duration on elements with class 'line-animator'
const setAnimationDuration = ( sliderObj, duration ) => {
  sliderObj.el.querySelectorAll( '.line-animator' )?.forEach( line => {
    line.style.animationDuration = `${duration}ms`;
  } );
};

addAction(
  'b3rg_tab_slider_content_init',
  'b3rg/tab-slider',
  ( settings, swiperTabContent, contentSwiper ) => {
    if ( contentSwiper.el.closest( 
      '.e-stn--tab-slider-v3 .e-tbs__content' 
    ) ) {
      
      const navSwiper = contentSwiper.thumbs.swiper;

      //set animation duration
      const animateDuration = settings.autoplay ? settings.autoplay?.delay + 500: 0;
      setAnimationDuration( navSwiper, animateDuration );

      contentSwiper.on( 'touchEnd', function ( ) {
        setAnimationDuration( navSwiper, 0 );
        stopAutoPlay( contentSwiper );
      } );

      // When user clicks the thumb slider, stop autoplay
      navSwiper.on( 'click', function ( ) {
        setAnimationDuration( navSwiper, 0 );
        stopAutoPlay( contentSwiper );
      } );

      //when user navigate navigation slider by clicking next button
      navSwiper.el.querySelector( '.swiper-button-next' ).addEventListener( 'click', () => {
        setAnimationDuration( navSwiper, 0 );
        stopAutoPlay( contentSwiper );
      } );

      //when user navigate navigation slider by clicking previous button
      navSwiper.el.querySelector( '.swiper-button-prev' ).addEventListener( 'click', () => {
        setAnimationDuration( navSwiper, 0 );
        stopAutoPlay( contentSwiper );
      } );
    }
  },
  10,
  1,
);


